"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invitation = void 0;
class Invitation {
    constructor(props) {
        this.att = props.att || false;
        this.check = props.check || false;
        this.corporate = props.corporate || null;
        this.corporateName = props.corporateName || "";
        this.date = props.date || "";
        this.destino_final = props.destino_final || undefined;
        this.dni = props.dni || "";
        this.handInputDni = props.handInputDni || "";
        this.last_att = props.last_att || null;
        this.id = props.id || "";
        this.registered = props.registered || false;
        this.response = props.response || "";
        this.sent_reminder = props.sent_reminder || false;
        this.status = props.status || undefined;
        this.timestamps = props.timestamps || {};
        this.type = props.type || "";
        this.ws = props.ws || "";
    }
}
exports.Invitation = Invitation;
